import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Shivani Joshi </span>
             from <span className="purple"> Uttarakhand, India.</span>
            <br />
            A fresher data analyst, I have a strong foundation in data analysis.
            <br />
            I have completed my Bachelor's degree in Computer Science & Engineering from Bipin Tripathi Kumaon Institute of Technology, Dwarahat (BTKIT).
            <br />
            <br />
            Apart from being an analyst and a developer, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Books
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to visualize things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Shivani</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
